module.exports = __webpack_public_path__ + "static/media/app-development.3956621a.png";